import {eqStrict} from 'fp-ts/lib/Eq';
import {flow} from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';

import {AppState} from '../../../store/appState';
import {Dispatch} from '../../../store/appStore';
import {Prefetcher} from './base';

/*
 * Factory.
 */

export interface OneTimePrefetcherOptions {
  key: string;
  computeCondition: (state: AppState) => O.Option<void>;
  prefetchAsync: (dispatch: Dispatch) => Promise<void>;
}

/** Creates a prefetcher that prefetches one thing. */
export function createOneTimePrefetcher(options: OneTimePrefetcherOptions): Prefetcher<void> {
  const {key, computeCondition, prefetchAsync} = options;

  return {
    key,
    C: eqStrict,
    // Our backlog is 1 if we have some condition, and 0 otherwise.
    computeBacklogLength: flow(
      computeCondition,
      O.fold(
        () => 0,
        () => 1,
      ),
    ),
    computeCondition,
    prefetchAsync,
  };
}
